import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import Layout from "../Layout";
import { useInfo } from "src/hooks/useData";
import { Link } from "react-router-dom";
import { useState } from "react";
import { printSafeWD } from "src/utils";
import { Spinner } from "flowbite-react";
import Button from "../Inputs/Button";
import SafeWDCalculator from "./SafeWDCalculator";

const SafeWd = () => {
  const { data, setField } = useInfo();
  const calc = data.safeWdCalculator || {};
  const setCalcField = (field: any) => (value: any) => {
    setField("safeWdCalculator")({
      ...calc,
      [field]: value,
    });
  };

  const [printing, setPrinting] = useState(false);
  const print = async () => {
    setPrinting(true);
    const url = await printSafeWD(data.id);
    setPrinting(false);
    window.open(url, "_blank");
  };

  return (
    <Layout page="calculator">
      <div className="p-6 rounded-lg">
        <div className="flex gap-3 items-center justify-between mb-8">
          <div className="flex gap-3 items-center">
            <Link to={`/client/${data.id}/calculator`}>
              <div className="rounded-full border border-gray-400 h-8 w-8 flex justify-center items-center cursor-pointer bg-white">
                <ArrowLeftIcon className="h-5 text-gray-500" />
              </div>
            </Link>
            <h1 className="text-3xl font-bold">Equivalent Yield (Annuity)</h1>
          </div>

          <div className="flex gap-2">
            <Button
              type="secondary"
              onClick={() => setField("safeWdCalculator")({})}
            >
              <div className="flex gap-2 p-1 px-3">Reset</div>
            </Button>
            <Button type="secondary" onClick={print}>
              <div className="flex gap-2 p-1 px-3">
                {printing && <Spinner className="h-5" />}
                <img
                  src="/icons/print.png"
                  className="h-6 w-6 cursor-pointer "
                />
              </div>
            </Button>
          </div>
        </div>
        <SafeWDCalculator calc={calc} setCalcField={setCalcField} />
      </div>
    </Layout>
  );
};

export default SafeWd;
